import { render, staticRenderFns } from "./Sync.vue?vue&type=template&id=bd9e6964&scoped=true&"
import script from "./Sync.vue?vue&type=script&lang=js&"
export * from "./Sync.vue?vue&type=script&lang=js&"
import style0 from "./Sync.vue?vue&type=style&index=0&id=bd9e6964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9e6964",
  null
  
)

export default component.exports